module.exports = __webpack_public_path__ + "a48fa2703332d68cbf85769fa6671a13.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-black-s.png
// module id = 2491
// module chunks = 0